import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'select',
        name: 'type',
        title: i18n.t('account.com.type'),
        rules: {required: true},
        options: {
            type: 'locale',
            data: [
                {id: 0, name:  i18n.t('account.com.gprs')},
                {id: 1, name:  i18n.t('account.com.pstn')},
                {id: 2, name:  i18n.t('account.com.ethernet')},
            ],
            label: 'name',
            track: 'id'
        },
        modal: ['com_type'],
        data: ['com_type',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'tracking_time',
        title: i18n.t('account.com.trackingTime'),
        rules: {required: true, numeric: true,},
        modal: ['tracking_time'],
        data: ['tracking_time'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'time',
        name: 'daily_time',
        title: i18n.t('account.com.dailyTime'),
        format:'HH:mm:ss',
        rules: {required: true},
        modal: ['daily_test_time'],
        data: ['daily_test_time'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'max_signal_count',
        title: i18n.t('account.com.maxSignal'),
        rules: {required: false, numeric: true},
        modal: ['max_signal_count'],
        data: ['max_signal_count'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'system_caller_id',
        title: i18n.t('account.com.callerId'),
        rules: {required: false},
        modal: ['system_caller_id'],
        data: ['system_caller_id'],
        additionalButton: false,
        checkBox: false
    },
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/Communications.js